import * as React from 'react';
import type { SVGProps } from 'react';
const SvgExploded = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path d="M16 11.135a.25.25 0 0 0-.2-.245l-.05-.005H4.232a.25.25 0 0 0-.25.25v3.701c0 .139.112.25.25.25H15.75a.25.25 0 0 0 .25-.25zm1.5 3.701a1.75 1.75 0 0 1-1.75 1.75H4.232a1.75 1.75 0 0 1-1.75-1.75v-3.7c0-.967.784-1.75 1.75-1.75H15.75l.178.008a1.75 1.75 0 0 1 1.572 1.741zM15.598 4l.077.004a.75.75 0 0 1 0 1.492l-.077.004H4.383a.75.75 0 0 1 0-1.5zM14.59 6.666l.077.004a.75.75 0 0 1 0 1.492l-.076.004H5.409a.75.75 0 0 1 0-1.5h9.182Z" />
  </svg>
);
export default SvgExploded;
